import type { App } from 'vue'
import { registerComponents } from './components'
import { organizationRoutingGuard } from './guards'

export * from './guards'

export const createSetup = () => ({
  install: (app: App) => {
    registerComponents(app)
    const router = app.getRouter()

    router.addRoute('organization', {
      path: 'setup/brand/source',
      name: 'setup-brand',
      meta: {
        setup: true,
        head: { titleKey: 'brands.newTitle' },
        brandFlow: {
          next: { name: 'setup-brand-step', params: { stepId: 'review' } },
          exit: { name: 'brand' }
        }
      },
      props: { stepId: 'source' },
      component: () => import('./pages/SetupPage.vue')
    })

    router.addRoute('organization', {
      path: 'setup/brand/:brandId/:stepId(review|typography)',
      name: 'setup-brand-step',
      meta: {
        setup: true,
        head: { titleKey: 'brands.newTitle' },
        brandFlow: {
          next: { name: 'setup-brand-step', params: { stepId: 'typography' } },
          exit: { name: 'brand' }
        }
      },
      props: route => ({
        stepId: route.params.stepId === 'typography' ? 'typography' : 'review'
      }),
      component: () => import('./pages/SetupPage.vue')
    })

    router.addRoute('organization', {
      path: 'setup/blocked',
      name: 'setup-blocked',
      meta: {
        setup: true,
        head: { titleKey: 'brands.setup.waitingTitle' }
      },
      props: { stepId: 'blocked' },
      component: () => import('./pages/SetupPage.vue')
    })

    router.beforeResolve(organizationRoutingGuard)
  }
})
